import { EXPERIMENT_SLUGS } from '../constants/experimentConstants'
import { experimentCore } from './experimentCore'

export const featureFlags = {
    get withPostRegPaywallStickyCtaMobile() {
        return experimentCore.getInExperimentVariation(
            EXPERIMENT_SLUGS.POST_REG_PAYWALL_STICKY_CTA_MOBILE,
            2,
        )
    },

    get withPlayer2ndAudioRegwall2() {
        return experimentCore.getInExperimentVariation(EXPERIMENT_SLUGS.PLAYER_2ND_AUDIO_REGWALL, 2)
    },

    get withCreatorProfileProOffer() {
        return experimentCore.getInExperimentVariation(
            EXPERIMENT_SLUGS.CONTEXTUAL_PRO_OFFER_CREATOR,
            2,
        )
    },

    get withPlayer2ndAudioRegwall3() {
        return experimentCore.getInExperimentVariation(EXPERIMENT_SLUGS.PLAYER_2ND_AUDIO_REGWALL, 3)
    },
}
